import { checkUsername } from 'api/user';
import { useQuery } from '@tanstack/react-query';

// Inspired from https://github.com/ReceiptProphet/delphi-rn-client/blob/main/src/hooks/useCheckUsername.ts

type CheckUsernameResult = {
  usernameFound: boolean;
};

export default function useUsernameChecker(username: string) {
  const queryResponse = useQuery<CheckUsernameResult>(
    ['usernameCheck', username],
    async () => await checkUsername(username),
    {
      enabled: !!username,
      onError: (err) => {
        console.error('Erorr checking username: ', err);
      },
    }
  );

  return {
    checkUsername: queryResponse.data?.usernameFound,
    checkUsernameLoading: queryResponse.isLoading,
    checkUsernameError: queryResponse.isError,
    fetching: queryResponse.isFetching,
  };
}
